import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import { Link, Router, Redirect } from "react-router-dom";
import { Dialog, Button, Form, Input, Select } from "element-react";
import AS from "./../Login/Service/Authentication";
import CS from "../../commons/services/Common";
import VS from "../../commons/services/Validation";
import MS from "../../commons/services/Moment";
import FileUpload from "../../commons/components/FileUpload";
import SelectBox from "../../commons/components/SelectBox";
import Date from "../../commons/components/Date";
import DateCustom from "../../commons/components/DateCustom";
import AddressSearch from "../../commons/components/AddressSearch"; // 2024.04 카카오 주소 검색 API 이용

/**
 * 발전소 등록 컴포넌트
 */
class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      isDialogVisible: false,
      plantId: "",
      inverterInfoOptions: [],
      moduleInfoOptions: [],
      modInfos: [],
      invInfos: [],
      structureInfos: [],
      searchAddressInfos: [],
      operationStartDt: "",
      serviceWarrantyDt: "",
      isLoading: true,
      inverters: [
        {
          key: 0,
          id: null,
          serialNo: null,
        },
      ],
      addrxy: { addr: "", x: "", y: "" }, // 2024.04
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.moveNextStep = this.moveModuleMatch.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setAddrXY = this.setAddrXY.bind(this); // 2024.04
    this.checkAddressValidation = this.checkAddressValidation.bind(this); // 2024.04

    this.fileInfos = {};
    this.item = {
      name: "",
      address: "",
      bizNum: "",
    };
  }

  componentDidMount() {
    this.getOptions();
  }

  async handleSubmit(e) {
    e.preventDefault();
    const data = new FormData(e.target);

    if (this.state.operationStartDt === "") {
      CS.notification("warning", "운전개시일은 필수 입력값 입니다.");
      return;
    }
    if (this.state.serviceWarrantyDt === "") {
      CS.notification("warning", "서비스보증 기간은 필수 입력값 입니다.");
      return;
    }

    this.item = {
      constructorId: AS.getLoggedInId(),
      name: data.get("name"),
      address: data.get("address"),
      latY: data.get("latY"),
      lngX: data.get("lngX"),
      bizNum: data.get("bizNum"),
      installationCnt: data.get("installationCnt"),
      installationCapacity: data.get("installationCapacity"),
      operationStartDt: this.state.operationStartDt, //data.get('operationYear') + "-" + CS.fillZero(2, data.get('operationMonth')) + "-" + CS.fillZero(2, data.get('operationDay')),
      serviceWarrantyDt: this.state.serviceWarrantyDt, //data.get('warrantyYear') + "-" + CS.fillZero(2, data.get('warrantyMonth')) + "-" + CS.fillZero(2, data.get('warrantyDay')),
      floorPlanFileInfo: this.fileInfos.floorPlanFile,
      oneLineDiagramFileInfo: this.fileInfos.oneLineDiagramFile,
      serialNoFileInfo: this.fileInfos.serialNoFile,
      unitPrice: data.get("unitPrice"),
      /*
            structure: data.get('structure'),
            structureBizName: data.get('structureBizName'),
            structureBizTelNum: data.get('structureBizTelNum'),
            electricWorkBizName: data.get('electricWorkBizName'),
            electricWorkBizTelNum: data.get('electricWorkBizTelNum'),
            */
    };

    let result = await CS.create("/cst/api/constructor-plant", this.item);
    if (result.isSuccess) {
      this.setState({
        plantId: result.res.data.newId,
      });
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      const newPlantInfos = result.res.data.plantInfos;
      userInfo.plantInfos = newPlantInfos;
      sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
    }
  }

  async getOptions() {
    let modInfos = await axios.get("/cst/api/mod-inv/MOD");
    modInfos = modInfos.data.map((obj) => {
      return {
        value: obj.id,
        text: obj.corpName,
      };
    });
    let invInfos = await axios.get("/cst/api/mod-inv/INV");
    invInfos = invInfos.data.map((obj) => {
      return {
        text: obj.corpName,
        value: obj.id,
      };
    });
    let structureInfos = await CS.getCodeInfo("STRUCTURE_TYPE");
    structureInfos = structureInfos.map((obj) => {
      return {
        text: obj.codeName,
        value: obj.code,
      };
    });

    const res1 = await axios.get("/cst/api/inverter-infos");
    const inverterInfoOptions = [];
    for (var key in res1.data) {
      const childOptions = [];
      res1.data[key].some((v) => {
        childOptions.push({
          value: v.id,
          label: v.name,
        });
      });
      inverterInfoOptions.push({
        label: key,
        options: childOptions,
      });
    }

    const res2 = await axios.get("/cst/api/module-infos");
    const moduleInfoOptions = [];
    for (var key in res2.data) {
      const childOptions = [];
      res2.data[key].some((v) => {
        childOptions.push({
          value: v.id,
          label: v.name,
        });
      });
      moduleInfoOptions.push({
        label: key,
        options: childOptions,
      });
    }

    this.setState({
      modInfos: modInfos,
      invInfos: invInfos,
      structureInfos: structureInfos,
      inverterInfoOptions: inverterInfoOptions,
      moduleInfoOptions: moduleInfoOptions,
      isLoading: false,
    });
  }

  doSetFile = (category, fileInfos) => {
    this.fileInfos[category] = fileInfos;
  };

  handleChange = (value) => {
    //alert(value);
  };

  /* 이전 작업 내용 - 시작 - 2024.04 */
  // findAddress = async () => {
  //   let infos = await CS.getAddressInfo(CS.$("#address"));
  //   if (infos.length > 0) {
  //     this.setState({
  //       isShow: true,
  //       searchAddressInfos: infos,
  //     });
  //   }
  // };
  /* 이전 작업 내용 - 끝 - 2024.04 */

  regist = () => {
    this.setState({
      isDialogVisible: true,
    });
  };

  checkUser = () => {
    let bizNum =
      CS.$("#bizNum1") + "-" + CS.$("#bizNum2") + "-" + CS.$("#bizNum3");
    axios
      .get(`/cst/api/check-bizNum/${bizNum}`)
      .then((res) => {
        document.getElementById("bizNum").value = bizNum;
      })
      .catch((error) => {
        CS.notification("warning", error.response.data.message);
      });
  };

  clickAddress = (address, latY, lngX) => {
    document.getElementById("address").value = address;
    document.getElementById("latY").value = latY;
    document.getElementById("lngX").value = lngX;
    this.setState({
      isShow: false,
      searchAddressInfos: [],
    });
  };

  moveModuleMatch(plantId) {
    if (plantId === "") {
      CS.notification("warning", "임시저장 후 모듈배치 화면으로 이동하세요.");
      return;
    }
    this.props.history.push(`/plant-list/drawing/${plantId}`);
  }

  moveEquipmentInfo(plantId) {
    if (plantId === "") {
      CS.notification("warning", "임시저장 후 장비 및 통신정보 화면으로 이동하세요.");
      return;
    }
    this.props.history.push(`/plant-list/equip/${plantId}`);
  }

  handleDateChange(name, dt) {
    this.setState({
      [name]: dt,
    });
  }

  // 2024.04
  setAddrXY(address, longitude, latitude) {
    this.setState({
      addrxy: { addr: address, x: longitude, y: latitude },
    });
  }

  // 2024.04
  checkAddressValidation(e) {
    alert("주소 검색을 이용해서 발전소 주소를 입력해주세요.");
    e.target.blur();
  }

  render() {
    const {
      isLoading,
      isShow,
      plantId,
      modInfos,
      invInfos,
      structureInfos,
      searchAddressInfos,
      operationStartDt,
      serviceWarrantyDt,
      inverterInfoOptions,
      moduleInfoOptions,
      inverters,
    } = this.state;

    if (isLoading) return <div>Loading...</div>;

    return (
      <>
        <div className="page-tit">
          <div className="container location">
            <h2 className="tit">전체 발전소 리스트</h2>
            <span>
              <strong>신규 발전소 등록</strong>
            </span>
          </div>
        </div>
        <div className="container pt-25">
          <form onSubmit={this.handleSubmit}>
            <input type="hidden" name="bizNum" id="bizNum" />
            <input
              type="hidden"
              name="latY"
              id="latY"
              value={this.state.addrxy.y} // 2024.04
            />
            <input
              type="hidden"
              name="lngX"
              id="lngX"
              value={this.state.addrxy.x} // 2024.04
            />
            <div className="mb-spacing10">
              <div className="card2 py-15">
                <div className="form-inline3">
                  <div className="form-group">
                    <label className="tit w110">발전소명</label>
                    <input
                      type="text"
                      className="w550"
                      name="name"
                      id="name"
                      placeholder="발전소명을 입력하세요."
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="card2 py-15 not-hidden">
                <div className="form-inline3">
                  <div className="form-group">
                    <label className="tit w110">발전소 주소</label>
                    <div className="addr-form">
                      <input
                        type="text"
                        className="w550"
                        name="address"
                        id="address"
                        placeholder="발전소 주소 검색을 이용하세요."
                        required
                        // onChange={this.findAddress} // 2024.04
                        defaultValue={this.state.addrxy.addr} // 2024.04
                        onFocus={this.checkAddressValidation} // 2024.04
                      />
                      {/* <button type="button" className="btn primary w160 ml-20" onClick={this.findAddress}>주소검색</button> */}{" "}
                      {/* 2024.04 */}
                      <AddressSearch setAddrXY={this.setAddrXY} />{" "}
                      {/* 2024.04 */}
                      <div
                        id="address_area"
                        className={
                          isShow
                            ? "address-layer w550 show"
                            : "address-layer w550"
                        }
                      >
                        {searchAddressInfos.map((row) => (
                          <div
                            key={row.address}
                            className="address-list"
                            onClick={() =>
                              this.clickAddress(
                                row.roadAddress,
                                row.latY,
                                row.lngX
                              )
                            }
                          >
                            <div className="road-num">
                              <span>지번</span>
                              {row.address}
                            </div>
                            <div className="road-name">
                              <span>도로명</span>
                              {row.roadAddress}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card2 py-15">
                <div className="form-inline3">
                  <div className="form-group">
                    <label className="tit w110">사업자 번호</label>
                    <input
                      type="text"
                      className="w120 center"
                      name="bizNum1"
                      id="bizNum1"
                      maxLength="3"
                      required
                      onChange={(e) => {
                        VS.onInput("number", e);
                      }}
                    />{" "}
                    -
                    <input
                      type="text"
                      className="w120 center ml-15"
                      name="bizNum2"
                      id="bizNum2"
                      maxLength="3"
                      required
                      onChange={(e) => {
                        VS.onInput("number", e);
                      }}
                    />{" "}
                    -
                    <input
                      type="text"
                      className="w260 center ml-15"
                      name="bizNum3"
                      id="bizNum3"
                      maxLength="5"
                      required
                      onChange={(e) => {
                        VS.onInput("number", e);
                      }}
                    />
                    <button
                      type="button"
                      className="btn primary w160 ml-20"
                      onClick={this.checkUser}
                    >
                      사용자 연결
                    </button>
                    {/* <button
                      type="button"
                      className="btn primary w160 ml-20"
                      onClick={this.regist}
                    >
                      모듈/인버터 등록
                    </button> */}
                  </div>
                </div>
              </div>
              <div className="card2 py-15">
                <div className="form-inline3 inline2">
                  <div className="form-group">
                    <label className="tit w110">설비 용량</label>
                    <span className="floting">
                      <input
                        type="text"
                        className="w100"
                        name="installationCapacity"
                        onChange={(e) => {
                          VS.onInput("number", e);
                        }}
                      />
                      <small className="unit right">kW</small>
                    </span>
                  </div>

                  <div className="form-group">
                    <label className="tit">설치 장수</label>
                    <span className="floting">
                      <input
                        type="text"
                        className="w100"
                        name="installationCnt"
                        onChange={(e) => {
                          VS.onInput("number", e);
                        }}
                      />
                      <small className="unit right">장</small>
                    </span>
                  </div>
                </div>
              </div>
              {/*
                            <div className="card2 py-15">
                                <div className="form-inline3 inline2">
                                    <div className="form-group">
                                        <label className="tit w110">태양광모듈 제조사</label>
                                        <SelectBox className="w115" name="moduleCompanyId" id="moduleCompanyId" default="선택" items={modInfos} handleSelectChange={this.handleChange} />
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w90">모듈 모델명</label>
                                        <input type="text" className="w110" name="moduleModelName" />
                                    </div>
                                    <div className="form-group">
                                        <label className="tit">설치 장수</label>
                                        <span className="floting">
                                            <input type="text" className="w80" name="installationCnt" onChange={(e) => {VS.onInput('number', e)}} />
                                            <small className="unit right">장</small>
                                        </span>
                                    </div>
                                    <div className="form-group">
                                        <label className="tit">설치 용량</label>
                                        <span className="floting">
                                            <input type="text" className="w80" name="installationCapacity" onChange={(e) => {VS.onInput('number', e)}} />
                                            <small className="unit right">kW</small>
                                        </span>
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w110">인버터 제조사</label>
                                        <SelectBox className="w115" name="inverterCompanyId" default="선택" items={invInfos} handleSelectChange={this.handleChange} />
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w90">인버터 모델명</label>
                                        <input type="text" className="w110" name="inverterModelName" />
                                    </div>
                                </div>
                            </div>
                            */}
              <div className="card2 py-15">
                <div className="form-inline3 inline2">
                  <div className="form-group">
                    <label className="tit w110">도면 배치도</label>
                    <FileUpload
                      className="w550"
                      handleUploadFile={this.doSetFile}
                      category="floorPlanFile"
                      accept="image/*"
                    />
                  </div>
                  <div className="form-group">
                    <label className="tit w110">단선결선도</label>
                    <FileUpload
                      className="w550"
                      handleUploadFile={this.doSetFile}
                      category="oneLineDiagramFile"
                      accept="image/*"
                    />
                  </div>
                  <div className="form-group">
                    <label className="tit w110">
                      모듈 인버터
                      <br />
                      시리얼 넘버
                    </label>
                    <FileUpload
                      className="w550"
                      handleUploadFile={this.doSetFile}
                      category="serialNoFile"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    />
                    <Link
                      to="/files/시리얼번호 양식파일.xlsx"
                      target="_blank"
                      download
                    >
                      <button type="button" className="btn primary w160 ml-20">
                        양식 파일(*.xlsx)
                      </button>
                    </Link>
                  </div>
                  <div className="form-group">
                    <label className="tit w110">운전 개시일</label>
                    <Date
                      name="operationStartDt"
                      handleDateChange={this.handleDateChange}
                    />
                  </div>
                  <div className="form-group">
                    <label className="tit w110">서비스 보증 기간</label>
                    <DateCustom
                      name="serviceWarrantyDt"
                      handleDateChange={this.handleDateChange}
                    />
                  </div>
                </div>
              </div>
              <div className="card2 py-15">
                <div className="form-inline3 inline2">
                  <div className="form-group">
                    <label className="tit w110">SMP + REC 가격</label>
                    1kW당
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      className="w220"
                      name="unitPrice"
                      onChange={(e) => {
                        VS.onInput("number", e);
                      }}
                    />
                    <label className="tit ml-10">원</label>
                  </div>
                </div>
              </div>

              {/*
                            <div className="card2 py-15">
                                <h3 className="content-tit1 mt-10 pl-0">외주용역정보</h3>
                                <div className="form-inline3 inline2">
                                    <div className="form-group">
                                        <label className="tit w100">기초(토목)공사</label>
                                        <select className="w120">
                                            <option value="">선택</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w80 text-right">외주업체명</label>
                                        <input type="text" className="w130" />
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w50 text-right">연락처</label>
                                        <input type="text" className="w240" />
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w100">구조물공사</label>
                                        <SelectBox className="w120" name="structure" id="structure" items={structureInfos} handleSelectChange={this.handleChange} />
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w80 text-right">외주업체명</label>
                                        <input type="text" className="w130" name="structureBizName" />
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w50 text-right">연락처</label>
                                        <input
                                            type="text" className="w240" name="structureBizTelNum" maxLength="13"
                                            onChange={(e) => {VS.onInput('phone', e)}} />
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w100">전기공사</label>
                                        <select className="w120">
                                            <option value="">선택</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w80 text-right">외주업체명</label>
                                        <input type="text" className="w130" name="electricWorkBizName" />
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w50 text-right">연락처</label>
                                        <input
                                            type="text" className="w240" name="electricWorkBizTelNum" maxLength="13"
                                            onChange={(e) => {VS.onInput('phone', e)}} />
                                    </div>
                                </div>
                            </div>
                            */}
            </div>
            {/*
                        <div className="card px-12 py-25 mt-15">
                            <div className="card-title">모듈 비정상 작동 알림 설정</div>
                            <div className="flex center">
                                <div className="form-inline">
                                    <div className="form-group">
                                        <label className="tit size15">시공사 알림</label>
                                        <div className="size15 bold">
                                            모듈이
                                            <span className="mx-15">
                                                <input type="text" className="w50 h40 style1" name="cstNoticeRate" onChange={(e) => {VS.onInput('number', e)}} />%
                                            </span>
                                            이상 비정상 작동일때 알림 설정
                                        </div>
                                    </div>
                                    <div className="form-group ml-70">
                                        <label className="tit size15">사용자 알림</label>
                                        <div className="size15 bold">
                                            모듈이
                                            <span className="mx-15">
                                                <input type="text" className="w50 h40 style1" name="usrNoticeRate" onChange={(e) => {VS.onInput('number', e)}} />%
                                            </span>
                                            이상 비정상 작동일때 알림 설정
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        */}
            <div className="card yellow text-center mt-15 pa-15">
              <strong className="size15 mr-20">
                모듈 배치와 장비 및 통신정보를 등록해주세요.
              </strong>
              <button
                type="button"
                className="btn secondary2 w300 size15 radius15 mr-10"
                onClick={() => this.moveModuleMatch(plantId)}
              >
                모듈 시리얼 넘버 매치
              </button>
              <button
                type="button"
                className="btn secondary2 w300 size15 radius15"
                onClick={() => this.moveEquipmentInfo(plantId)}
              >
                장비 및 통신 정보
              </button>
            </div>
            {/* <div className="btn-areaC1 pb-50">
              <button type="submit" className="btn">
                임시저장
              </button>
              <button type="button" className="btn primary" disabled>
                등록완료
              </button>
            </div> */}
            <div className="btn-areaC2">
              <button type="submit" className="btn primary">
                저장
              </button>
            </div>
          </form>
        </div>

        <Dialog
          title="인버터/모듈 등록"
          lockScroll={false}
          size="small"
          visible={this.state.isDialogVisible}
          onCancel={() => this.setState({ isDialogVisible: false })}
        >
          <Dialog.Body>
            <div className="form-group">
              <label className="tit w110">인버터</label>
              {inverters.map((inv, idx1) => (
                <div key={idx1}>
                  <Select
                    placeholder="인버터선택"
                    filterable={true}
                    onChange={(e) =>
                      this.handleInverterChange("id", inv.key, e)
                    }
                  >
                    {inverterInfoOptions.map((group) => {
                      return (
                        <Select.OptionGroup
                          key={group.label}
                          label={group.label}
                          filterable={true}
                        >
                          {group.options.map((el) => {
                            return (
                              <Select.Option
                                key={el.value}
                                label={el.label}
                                value={el.value}
                              >
                                <span style={{ float: "left" }}>
                                  {el.label}
                                </span>
                              </Select.Option>
                            );
                          })}
                        </Select.OptionGroup>
                      );
                    })}
                  </Select>
                  <input
                    type="text"
                    className="w250 center ml-15"
                    placeholder="시리얼번호입력"
                    onChange={(e) =>
                      this.handleInverterChange(
                        "serialNo",
                        inv.key,
                        e.target.value
                      )
                    }
                  />
                  <button
                    type="button"
                    className="btn primary w100 ml-20"
                    onClick={() => this.addModule(inv.key)}
                  >
                    모듈추가
                  </button>
                  <br />
                  {inv.modules === undefined ? (
                    <></>
                  ) : (
                    inv.modules.map((mod, idx2) => (
                      <>
                        <Select
                          name="2"
                          placeholder="모듈선택"
                          filterable={true}
                          onChange={(e) =>
                            this.handleModuleChange("id", inv.key, mod.key, e)
                          }
                        >
                          {moduleInfoOptions.map((group) => {
                            return (
                              <Select.OptionGroup
                                key={group.label}
                                label={group.label}
                              >
                                {group.options.map((el) => {
                                  return (
                                    <Select.Option
                                      key={el.value}
                                      label={el.label}
                                      value={el.value}
                                    >
                                      <span style={{ float: "left" }}>
                                        {el.label}
                                      </span>
                                    </Select.Option>
                                  );
                                })}
                              </Select.OptionGroup>
                            );
                          })}
                        </Select>
                        <input
                          type="text"
                          className="w250 center ml-15"
                          placeholder="시리얼번호입력"
                          onChange={(e) =>
                            this.handleModuleChange(
                              "serialNo",
                              inv.key,
                              mod.key,
                              e.target.value
                            )
                          }
                        />
                        <button
                          type="button"
                          className="btn red w100 ml-20"
                          onClick={() => this.deleteModule(inv.key)}
                        >
                          삭제
                        </button>
                        <br />
                      </>
                    ))
                  )}
                </div>
              ))}
            </div>
          </Dialog.Body>

          <Dialog.Footer className="dialog-footer">
            <Button type="primary" onClick={this.addInverter}>
              인버터추가
            </Button>
            <Button onClick={() => this.setState({ isDialogVisible: false })}>
              취소
            </Button>
            <Button
              type="primary"
              onClick={() => this.setState({ isDialogVisible: false })}
            >
              확인
            </Button>
          </Dialog.Footer>
        </Dialog>
      </>
    );
  }

  handleInverterChange = (div, key, value) => {
    const inverters = this.state.inverters;
    inverters.some((v) => {
      if (v.key === key) {
        v[div] = value;
        return true;
      }
    });
    this.setState({
      inverters: inverters,
    });
  };

  handleModuleChange = (div, inverterKey, moduleKey, value) => {
    const inverters = this.state.inverters;
    inverters.some((v) => {
      if (v.key === inverterKey) {
        v.modules.some((w) => {
          if (w.key === moduleKey) {
            w[div] = value;
            return true;
          }
        });
      }
    });
    //console.log(inverters)
    this.setState({
      inverters: inverters,
    });
  };

  addInverter = () => {
    const inverters = this.state.inverters;
    inverters.push({
      key: inverters.length,
      id: null,
      serialNo: null,
    });
    this.setState({
      inverters: inverters,
    });
  };

  addModule = (key) => {
    const inverters = this.state.inverters;
    inverters.some((v) => {
      if (v.key === key) {
        if (v.modules === undefined) {
          v.modules = [];
          v.modules.push({
            key: 1,
            id: null,
            serialNo: null,
          });
        } else {
          const maxModuleKey = v.modules.length;
          v.modules.push({
            key: maxModuleKey + 1,
            id: null,
            serialNo: null,
          });
        }
        return true;
      }
    });
    this.setState({
      inverters: inverters,
    });
  };
}

export default Create;
